import {createUseStyles} from "react-jss";
import {breakpoints} from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";

const styles = createUseStyles(theme =>({
  modalContent: {
    margin: "22px 0 0 0"
  },
  checkbox: {
    marginRight: "12px"
  },
  invitePeopleModal: {
    width: "400px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    },
    "& .modal-body":{
      padding:"8px 24px 24px",
    },
    "& .modal-title":{
      display:"flex",
      justifyContent:"center",
      padding: "0px"
    },
    "& .modal-header":{
      padding: "24px 24px 20px 24px",
      marginLeft: "152px",
      flexDirection: "row",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        marginLeft: "0px",
        "& div": {
          marginLeft: "auto",
          marginRight: "-22px"  
        }
      }, 
      "& button": {
        fontSize: "14px",
        marginBottom: "10px",
        "&:focus":{
          boxShadow:"none",
          border: `1px solid ${colors.black}`,
        },
      },
      
    },
  },

  cancelBtn: {
    padding:"10px 0px",
    display:"flex",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"24px",
    width: "169px",
    height: "100%",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "97%"
    },
  },
  saveBtn: {
    padding:"10px 0px",
    display:"flex",
    justifyContent:"center",
    textAlign:"center",
    borderRadius:"8px",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"24px",
    width: "169px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "97%"
    },
  },
  sendButtonRow:{
    padding: "0px ",
    display:"flex",
    justifyContent:"flex-end",
  },
  cancelButtonRow:{
    padding: "0px",
  },
  roles: {
    textAlign:"left",
  },
  rolesWrapper: {
   marginBottom:"32px",
  },
  dividerStyle:{
    marginTop:"17.5px",
    marginBottom:"17.5px",
  },
  content:{
    padding:0,
  },
  label:{
    fontSize: "14px",
    color: colors.grey,
    fontWeight:"500",
    lineHeight:"20px",
    marginBottom:"6px"
  },
  inputField:{
    width:"100%",
    height:"128px",
    border:`1px solid ${colors.darkGrey}`,
    borderRadius:"8px",
    textAlign:"start"
  },
  text:{
    fontSize: "14px",
    color: colors.mediumGrey,
    fontWeight:"400",
    lineHeight:"20px",
    marginTop:"6px",
    textAlign:"left",
  },
  roleText:{
    fontSize: "14px",
    color: colors.grey,
    fontWeight:"500",
    lineHeight:"20px",
    marginTop:"20px",
    marginBottom:"6px",
    textAlign:"left",
    display: "flex",
    alignItems: "center",
  },
  manageText:{
    fontSize: "14px",
    color: colors.mediumGrey,
    fontWeight:"400",
    lineHeight:"20px",
    marginTop:"6px",
    textAlign:"left",
    "& a":{
      textDecoration:"none",
      color: theme.buttons.defaultLink.color,
      fontWeight: "600",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      whiteSpace: "unset",
    },
  },
  inputGroupWrapper:{
    flexWrap: "nowrap",
  },
  inputGroup:{
    fontSize: "16px",
    color: colors.lightBlack,
    fontWeight:"400",
    lineHeight:"24px",
    backgroundColor: colors.white,
    maxWidth:"245px",
    overflow:"hidden",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      maxWidth:"70%",
    },
  },
  inputGroupButton:{
    backgroundColor: colors.white,
    border:"none",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding:"0px 4px"
    },
    "&:hover":{
      backgroundColor: colors.white,
      border:"none"
    },
    "&:focus-visible":{
      boxShadow:"none",
      border: `1px solid ${colors.black}`,
      backgroundColor: colors.white,
    },
  },
  inputCopyWrapper: {
    display: "flex",
    gap: "8px"
  },
  inputCopyIcon: {
    marginLeft: "-6px"
  },
  inputCopyText: {
    fontSize: "16px",
    color: colors.grey,
    fontWeight:"600",
    lineHeight:"24px"
  },
  disabled: {
    color: colors.paleGrey,
    backgroundColor: colors.brightBlue,
    pointerEvents: "none",
  },
  disabledButton: {
    color: colors.darkGrey,
    backgroundColor: colors.brightBlue,
    "& path": {
      stroke: colors.darkGrey
    }
  },
  popoverDiv:{
    display:"flex",
    alignItems:"center",
    backgroundColor:  colors.white,
    padding: '8px 12px',
    borderRadius: 8,
    color:  colors.grey,
  },
  popover:{
    "& .popover-arrow::before": {
      border:"none",
    },
    border:"none",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
  },
  infoIcon:{
    marginLeft:"5px",
    cursor: "pointer",
    "& path": {
      stroke: colors.inactiveGrey
    }
  },
  tooltip: {
    "& .tooltip-inner": {
      maxWidth: "320px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign:"start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    }
  },
  infoTitle:{
    fontSize: "12px",
    fontWeight:"600",
    lineHeight:"18px",
    marginBottom: "4px"
  },
  infoDescriptionAdmin:{
    extend: "infoDescription",
    marginBottom: "12px"
  },
  infoDescription:{
    fontSize: "12px",
    fontWeight:"500",
    lineHeight:"18px",
  },
  container:{
    display: "flex",
    alignItems: "center",
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },
  emailsError: {
    display: "flex",
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    marginTop: "6px"
  },
  invitePeopleDescription: {
    textAlign: "center",
    fontSize: "14px",
    color: colors.inactiveGrey,
    margin: "0px"
  },
  btnRow:{
    margin:"0px",
  }
}));

export default styles;
